// src/components/Charts/PortComparisonChart.jsx
import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const PortComparisonChart = () => {
  const data = {
    labels: ['Singapore', 'Shanghai', 'Rotterdam', 'Dubai', 'Los Angeles'],
    datasets: [{
      label: 'Monthly Throughput (Tons)',
      data: [185430, 245820, 142580, 98750, 165320],
      backgroundColor: [
        '#4da6ff',
        '#ff6384',
        '#4cd964',
        '#ff9f40',
        '#9966ff'
      ],
      borderColor: [
        '#0a2c5e',
        '#c82333',
        '#28a745',
        '#e68a36',
        '#6f42c1'
      ],
      borderWidth: 1
    }]
  };

  const options = {
    responsive: true,
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Tons'
        },
        grid: {
          color: 'rgba(0, 0, 0, 0.05)'
        }
      },
      x: {
        grid: {
          display: false
        }
      }
    },
    plugins: {
      legend: {
        position: 'top',
      }
    }
  };

  return <Bar data={data} options={options} />;
};

export default PortComparisonChart;